// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};


export const SERVER_URL = 'https://api.staging2.megaincentivos.com';
// export const SERVER_URL = 'http://0.0.0.0:8000/api';
// export const SERVER_URL = 'http://server.inkrementaldev.co:8050/api';
export const API_GATEWAY_URL = 'https://api.staging2.megaincentivos.com';
export const SOCKET_URL = 'wss://6hf9zkqidg.execute-api.us-west-2.amazonaws.com/staging'
export const MEGAPAY_URL = 'https://wallet.staging.megaincentivos.com';

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
